import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import { useArgonController } from 'context';

import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

const InfographicCard = ({ bgColor, color, icon, title, description, value }) => {
    const [controller] = useArgonController();
    const { darkMode } = controller;

    return (
        <Card>
            <ArgonBox bgColor={bgColor === "white" && darkMode ? "transparent" : bgColor}>
                <ArgonBox p={2} mx={3} display="flex" justifyContent="center">
                    <ArgonBox
                        bgColor={bgColor === "white" ? color : "white"}
                        color={bgColor === "white" ? "white" : "dark"}
                        width="3rem"
                        height="3rem"
                        borderRadius="section"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        shadow="md"
                    >
                        <Icon fontSize="small" color='text'>
                            {icon}
                        </Icon>
                    </ArgonBox>
                </ArgonBox>
                <ArgonBox pb={2} px={2} textAlign="center" lineHeight={1.25} color={bgColor === "white" ? color : "white"}>
                    <ArgonTypography variant="h6" fontWeight="medium" textTransform="capitalize" color='inherit'>
                        {title}
                    </ArgonTypography>
                    {description && (
                        <ArgonTypography variant="caption" color='inherit' fontWeight="regular" >
                            {description}
                        </ArgonTypography>
                    )}
                    {value && (
                        <ArgonTypography variant="h3" fontWeight="bold" color='inherit'>
                            {value}
                        </ArgonTypography>
                    )}
                </ArgonBox>
            </ArgonBox>
        </Card>
    )
}

InfographicCard.defaultProps = {
    color: "text",
    value: "",
    description: "",
};

export default InfographicCard